import React, { Component } from 'react';
import './Fields.css'
import moment from 'moment';
import Select from 'react-select';
import Api from '../services/api';
import AuthService from '../services/auth';
import checkCircle from '../static/vectors/check-circle.svg';
import Modal from 'react-modal';

class ProfileBasic extends Component {

  constructor(props) {
    super(props);
    let optionsDay = [];
    let optionsMonth = [];
    let optionsYear = [];
    let optionsLifestyleExpectations = [
      {
        value: 'negotiable',
        label: 'Negotiable',
      },
      {
        value: 'moderate',
        label: 'Moderate',
      },
      {
        value: 'high',
        label: 'High',
      },
    ];

    for(let i = 1; i <= 31 ; i += 1) {
      optionsDay.push({
        value: (i < 10)?`0${i}`:i.toString(),
        label: i.toString(),
      });
    }

    const months = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];


    for(let i = 0; i<12; i += 1) {
      optionsMonth.push({
        value: (i+1 < 10)?`0${i+1}`:(i+1).toString(),
        label: months[i],
      });
    }

    for(let i = parseInt(moment().format('YYYY'), 10) - 18; i >= parseInt(moment().format('YYYY'), 10) - 100; i -= 1) {
      optionsYear.push({
        value: i.toString(),
        label: i.toString(),
      });
    }

    this.state = {
      fields: {
        name: '',
        headline: '',
        dob_d: optionsDay[0].value,
        dob_m: optionsMonth[0].value,
        dob_y: optionsYear[0].value,
        lookingFor: [],
        lifestyleExpectations: '',
      },
      optionsDay,
      optionsMonth,
      optionsYear,
      optionsLifestyleExpectations,
      isModalOpen: false,
      modalMessage: '',
      canSubmit: false,
    };
  }

  componentDidMount() {
    (new Api()).get('/users/current',{}, AuthService.getAuthCookie())
      .then(response => {
        const {id, name, birthDate, headline, lifestyleExpectations, accountType} = response.user;
        const [dob_y, dob_m, dob_d] = birthDate.split('-');
        let lookingFor = response.user.lookingFor.substr(-1,1);
        if(lookingFor === 'a') {
          lookingFor = ['M', 'F'];
        } else {
          lookingFor = [lookingFor.toUpperCase()];
        }
        this.setState({

          fields: {
            accountType,
            name,
            headline,
            lookingFor,
            lifestyleExpectations,
            dob_y,
            dob_m,
            dob_d,
          },
          id,
        });
      });
  }

  handleSubmit(e) {
    e.preventDefault();
    let { fields, id } = this.state;
    let suffix = '';
    let prefix = '';
    if(fields.lookingFor.length > 1) {
      suffix = 'a';
    } else {
      suffix = fields.lookingFor[0].toLowerCase();
    }
    if(fields.accountType === 'sugar_parent') {
      prefix = 'sugar_baby'
    } else {
      prefix = 'sugar_parent'
    }

    fields.lookingFor = `${prefix}_${suffix}`;

    (new Api()).put(`/users/${id}`, fields, AuthService.getAuthCookie())
      .then(response => {
        const {id, name, birthDate, headline, lifestyleExpectations, accountType} = response.user;
        const [dob_y, dob_m, dob_d] = birthDate.split('-');
        let lookingFor = response.user.lookingFor.substr(-1,1);
        if(lookingFor === 'a') {
          lookingFor = ['M', 'F'];
        } else {
          lookingFor = [lookingFor.toUpperCase()];
        }
        this.setState({
          fields: {
            accountType,
            name,
            headline,
            lookingFor,
            lifestyleExpectations,
            dob_y,
            dob_m,
            dob_d,
          },
          isModalOpen: true,
          canSubmit: false,
          modalMessage: response.message,
          id,
        });
      });
  }

  handleFieldChange(e, name) {
    let fields = this.state.fields;

    if (name === 'lookingFor') {
      if(e.target.checked) {
        if (!fields.lookingFor.includes(e.target.value)) {
          fields.lookingFor.push(e.target.value);
        }
      } else {
        const index = fields.lookingFor.indexOf(e.target.value);
        if (index > -1) {
          fields.lookingFor.splice(index, 1);
        }
      }
    }else{
      if (name.includes('dob') || name.includes('lifestyle')) {
        fields[name] = e;
      } else {
        fields[name] = e.target.value;
      }
    }

    this.setState({ fields,
      canSubmit: true, });
  }

  closeModal() {
    this.setState({
      isModalOpen: false,
    });
  }

  render() {
    const { fields, optionsLifestyleExpectations, isModalOpen, modalMessage, canSubmit } = this.state;
    const { title } = this.props;
    return (
      <div className="col col-12 col-md-8">
        <div className="title">
          {title}
        </div>
        <form>
          <div className="field-container text">
            <div className="field-title">Username:</div>
            <div className="row">
              <div className="col">
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={fields.name}
                  onChange={e => {this.handleFieldChange(e, e.target.name)}}
                />
              </div>
            </div>
          </div>
          <div className="field-container text">
            <div className="field-title">Headline:</div>
            <div className="row">
              <div className="col">
                <input
                  type="text"
                  id="headline"
                  name="headline"
                  value={fields.headline}
                  onChange={e => {this.handleFieldChange(e, e.target.name)}}
                />
              </div>
            </div>
          </div>
          <div className="field-container select dob">
            <div className="field-title">Your birthday:</div>
            <div className="row">
              <div className="col">
                <Select
                  name="dob_d"
                  onChange={value => this.handleFieldChange(value.value, 'dob_d')}
                  options={this.state.optionsDay}
                  placeholder="Day"
                  value={fields.dob_d}
                  clearable={false}
                />
              </div>
              <div className="col">
                <Select
                  name="dob_m"
                  onChange={value => this.handleFieldChange(value.value, 'dob_m')}
                  options={this.state.optionsMonth}
                  placeholder="Month"
                  value={fields.dob_m}
                  clearable={false}
                />
              </div>
              <div className="col">
                <Select
                  name="dob_y"
                  onChange={value => this.handleFieldChange(value.value, 'dob_y')}
                  options={this.state.optionsYear}
                  placeholder="Year"
                  value={fields.dob_y}
                  clearable={false}
                />
              </div>
            </div>
          </div>
          <div className="field-container checkbox">
            <div className="field-title">Looking for:</div>
            <div className="row">
              <div className="col">
                <input
                  type="checkbox"
                  id="lookingForM"
                  name="lookingFor"
                  checked={fields.lookingFor.includes('M')}
                  value="M"
                  onChange={e => {this.handleFieldChange(e, e.target.name)}}
                />
                <label className="field-title" htmlFor="lookingForM">Men</label>
                <input
                  type="checkbox"
                  id="lookingForF"
                  name="lookingFor"
                  checked={fields.lookingFor.includes('F')}
                  value="F"
                  onChange={e => {this.handleFieldChange(e, e.target.name)}}
                />
                <label className="field-title" htmlFor="lookingForF">Women</label>
              </div>
            </div>
          </div>
          <div className="field-container select">
            <div className="field-title">Lifestyle</div>
            <div className="row">
              <div className="col">
                <Select
                  name="lifestyleExpectations"
                  onChange={value => this.handleFieldChange(value.value, 'lifestyleExpectations')}
                  options={optionsLifestyleExpectations}
                  placeholder="Please select"
                  value={fields.lifestyleExpectations}
                  clearable={false}
                />
              </div>
            </div>
          </div>
        </form>
        <button
          className="submit btn"
          disabled={!canSubmit}
          onClick={(e) => {this.handleSubmit(e);}}
        >
          Save profile
        </button><Modal
        isOpen={isModalOpen}
        onRequestClose={() => {this.closeModal()}}
        contentLabel="Example Modal"
        style={{
          content: {
            top: '50%',
            bottom: 'auto',
            left: '50%',
            right: 'auto',
            transform: 'translate(-50%, -50%)',
          }
        }}
      >
        <div className="content text-center">
          <img src={checkCircle} alt="check" />
          <div className="message">{modalMessage}</div>
          <button onClick={() => {this.closeModal()}}> Close X</button>
        </div>
      </Modal>
      </div>
    )
  }
}

export default ProfileBasic;


// WEBPACK FOOTER //
// ./src/components/ProfileBasic.js